function countDown(resetHour) {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const resetTime = new Date(year, month, day, resetHour, 0, 0).getTime();
    let distance = resetTime - now.getTime();
  
    // Si ya pasó la hora de reinicio de hoy, calcula la hora de reinicio del próximo día
    if (distance <= 0) {
      const tomorrow = new Date(year, month, day + 1, resetHour, 0, 0);
      distance = tomorrow.getTime() - now.getTime();
    }
  
    let hours = Math.floor(distance / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    hours  = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    document.getElementById("hours").innerText  = hours + " : ";
    document.getElementById("minutes").innerText = minutes + " : ";
    document.getElementById("seconds").innerText = seconds;
  }
  
  //const resetHour = 13; // Cambiar a la hora de reinicio que desees
   //const resetHour = 0 // 12 de la noche;
   //countDown(resetHour);
   //setInterval(() => countDown(resetHour), 1000);
  